import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ConfigManagerService = /** @class */ (function () {
    function ConfigManagerService(http) {
        this.http = http;
        this.platform_override = 'app_platform_override';
        this.app_override = 'app_override';
        this.planObject = {};
    }
    ConfigManagerService.prototype.setPlanObject = function (planObject) {
        this.planObject = planObject;
    };
    ConfigManagerService.prototype.returnTheConfig = function (appObj) {
        // const appObj = this.appSelectorService.getSelectedApp();
        if (appObj && this.planObject[appObj.id]) {
            return this.planObject[appObj.id];
        }
        else if (appObj && this.planObject[appObj.os]) {
            return this.planObject[appObj.os];
        }
        else {
            return this.planObject['default'];
        }
    };
    ConfigManagerService.prototype.isPropertyPresentInList = function (listName, property, appObj, cb) {
        var configJson = this.returnTheConfig(appObj);
        var flag = configJson[listName] && configJson[listName].hasOwnProperty(property);
        cb && cb(flag);
    };
    ConfigManagerService.ngInjectableDef = i0.defineInjectable({ factory: function ConfigManagerService_Factory() { return new ConfigManagerService(i0.inject(i1.HttpClient)); }, token: ConfigManagerService, providedIn: "root" });
    return ConfigManagerService;
}());
export { ConfigManagerService };
